import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export const SectionRow = styled(Row)`
  margin-top: ${props => (props.thin ? '20' : '30')}px;
`
